module.exports = __webpack_public_path__ + "media/images/icons/icon-product_7-ce5932777c3e7efc7db916939cefc71e.svg";